import { getRequest, postRequest } from '@/utils/fetch';
// css作废售后单
export const getAftersaleInvalid = (params: any) => {
    return postRequest('/css/aftersale/invalid', params);
};

//css售后工单详情V2
export const getAftersaleDetailV2 = (params: any) => {
    return getRequest('/css/aftersale/detail/v2', params);
};

//修改换货商品信息
export const getModifyProductV2 = (params: any) => {
    return postRequest('/css/aftersale/v2/modify/product', params);
};

//css优惠券相关接口
export const couponInvalidV2 = (params: any) => {
    return postRequest('/css/coupon/invalid/v2', params);
};

//瑕疵原因
export const aftersaleReasonList = (params: any) => {
    return postRequest('/aftersale/reason/list', params);
};
// css 更新商品信息 - 更新明盒信息
export const updateGoodsInfo = (params: any) => {
    return postRequest('/css/aftersale/update/goods', params);
};

// 更新售后单 接收短信手机号
export const updateTel = (params: any) => {
    return postRequest('/css/aftersale/updateTel', params);
};

// 更新售后单信息
export const updateAfterSaleInfo = (params: any) => {
    return postRequest('/css/aftersale/update', params);
};
// css css系统-确认收货
export const aftersaleConfirm = (params: any) => {
    return postRequest('/css/aftersale/confirm', params);
};
// 瑕疵配置列表原因
export const aftersaleReasonConfigList = (params: any) => {
    return postRequest('/aftersale/reason/config/list', params);
};
// 瑕疵配置列表原因
export const aftersaleReasonConfigOnEnableChange = (params: any) => {
    return postRequest('/aftersale/reason/config/onOff', params);
};

// 升级工单校验
export const upgradeWorkOrderCheck = (params: any) => {
    return postRequest(
        '/work-order/workOrder/work/upgradeWorkOrderCheck',
        params,
    );
};
// 关闭任务节点
export const workOrderTaskNodeFinish = (params: { id: number }) => {
    return getRequest('/work-order/workOrder/workOrderTaskNode/finish', params);
};

// 任务标签枚举
export const workOrderTaskNodeTagEnum = (params: any) => {
    return getRequest(
        '/work-order/workOrder/workOrderTaskNode/tagEnum',
        params,
    );
};

//升级工单确认
export const upgradeWorkOrder = (params: any) => {
    return postRequest('/work-order/workOrder/work/upgradeWorkOrder', params);
};
//补充信息
export const workAppendInfo = (params: {
    attachmentList: string[];
    replyContent: string;
    taskTag: number;
    workOrderNo: string;
}) => {
    return postRequest('/work-order/workOrder/work/appendInfo', params);
};

// 重新发送支付短信通知
export const sendExpressPayMessage = (params: { after_sale_no: string }) => {
    return postRequest('/css/aftersale/sendExpressPayMessage', params);
};
